export const TooltipPositions = ['top', 'right', 'bottom', 'left'];
